import { createGlobalStyle } from 'styled-components';

import ManropeExtraLight from './fonts/Manrope/Manrope-ExtraLight.woff';
import ManropeLight from './fonts/Manrope/Manrope-Light.woff';
import ManropeRegular from './fonts/Manrope/Manrope-Regular.woff';
import ManropeMedium from './fonts/Manrope/Manrope-Medium.woff';
import ManropeSemiBold from './fonts/Manrope/Manrope-SemiBold.woff';
import ManropeBold from './fonts/Manrope/Manrope-Bold.woff';
import ManropeExtraBold from './fonts/Manrope/Manrope-ExtraBold.woff';

import NunitoSansExtraLight from './fonts/NunitoSans/NunitoSans-ExtraLight.woff';
import NunitoSansExtraLightItalic from './fonts/NunitoSans/NunitoSans-ExtraLightItalic.woff';
import NunitoSansLight from './fonts/NunitoSans/NunitoSans-Light.woff';
import NunitoSansLightItalic from './fonts/NunitoSans/NunitoSans-LightItalic.woff';
import NunitoSansRegular from './fonts/NunitoSans/NunitoSans-Regular.woff';
import NunitoSansItalic from './fonts/NunitoSans/NunitoSans-Italic.woff';
import NunitoSansSemiBold from './fonts/NunitoSans/NunitoSans-SemiBold.woff';
import NunitoSansSemiBoldItalic from './fonts/NunitoSans/NunitoSans-SemiBoldItalic.woff';
import NunitoSansBold from './fonts/NunitoSans/NunitoSans-Bold.woff';
import NunitoSansBoldItalic from './fonts/NunitoSans/NunitoSans-BoldItalic.woff';
import NunitoSansExtraBold from './fonts/NunitoSans/NunitoSans-ExtraBold.woff';
import NunitoSansExtraBoldItalic from './fonts/NunitoSans/NunitoSans-ExtraBoldItalic.woff';
import NunitoSansBlack from './fonts/NunitoSans/NunitoSans-Black.woff';
import NunitoSansBlackItalic from './fonts/NunitoSans/NunitoSans-BlackItalic.woff';

import OpenSansLight from './fonts/OpenSans/OpenSans-Light.woff';
import OpenSansLightItalic from './fonts/OpenSans/OpenSans-LightItalic.woff';
import OpenSansRegular from './fonts/OpenSans/OpenSans-Regular.woff';
import OpenSansItalic from './fonts/OpenSans/OpenSans-Italic.woff';
import OpenSansSemiBold from './fonts/OpenSans/OpenSans-SemiBold.woff';
import OpenSansSemiBoldItalic from './fonts/OpenSans/OpenSans-SemiBoldItalic.woff';
import OpenSansBold from './fonts/OpenSans/OpenSans-Bold.woff';
import OpenSansBoldItalic from './fonts/OpenSans/OpenSans-BoldItalic.woff';
import OpenSansExtraBold from './fonts/OpenSans/OpenSans-ExtraBold.woff';
import OpenSansExtraBoldItalic from './fonts/OpenSans/OpenSans-ExtraBoldItalic.woff';

import RobotoMedium from './fonts/Roboto/Roboto-Medium.ttf';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Manrope';
    font-weight: 200;
    font-style: normal;
    font-display: fallback;
    src: url(${ManropeExtraLight}) format('woff')
  }
  @font-face {
    font-family: 'Manrope';
    font-weight: 300;
    font-style: normal;
    font-display: fallback;
    src: url(${ManropeLight}) format('woff')
  }
  @font-face {
    font-family: 'Manrope';
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
    src: url(${ManropeRegular}) format('woff')
  }
  @font-face {
    font-family: 'Manrope';
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
    src: url(${ManropeMedium}) format('woff')
  }
  @font-face {
    font-family: 'Manrope';
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
    src: url(${ManropeSemiBold}) format('woff')
  }
  @font-face {
    font-family: 'Manrope';
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
    src: url(${ManropeBold}) format('woff')
  }
  @font-face {
    font-family: 'Manrope';
    font-weight: 800;
    font-style: normal;
    font-display: fallback;
    src: url(${ManropeExtraBold}) format('woff')
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 200;
    font-style: normal;
    font-display: fallback;
    src: url(${NunitoSansExtraLight}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 200;
    font-style: italic;
    font-display: fallback;
    src: url(${NunitoSansExtraLightItalic}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 300;
    font-style: normal;
    font-display: fallback;
    src: url(${NunitoSansLight}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 300;
    font-style: italic;
    font-display: fallback;
    src: url(${NunitoSansLightItalic}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
    src: url(${NunitoSansRegular}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 400;
    font-style: italic;
    font-display: fallback;
    src: url(${NunitoSansItalic}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
    src: url(${NunitoSansSemiBold}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 600;
    font-style: italic;
    font-display: fallback;
    src: url(${NunitoSansSemiBoldItalic}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
    src: url(${NunitoSansBold}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 700;
    font-style: italic;
    font-display: fallback;
    src: url(${NunitoSansBoldItalic}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 800;
    font-style: normal;
    font-display: fallback;
    src: url(${NunitoSansExtraBold}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 800;
    font-style: italic;
    font-display: fallback;
    src: url(${NunitoSansExtraBoldItalic}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 900;
    font-style: normal;
    font-display: fallback;
    src: url(${NunitoSansBlack}) format('woff');    
  }
  @font-face {
    font-family: 'NunitoSans';
    font-weight: 900;
    font-style: italic;
    font-display: fallback;
    src: url(${NunitoSansBlackItalic}) format('woff');    
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 300;
    font-style: normal;
    font-display: fallback;
    src: url(${OpenSansLight}) format('woff');
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 300;
    font-style: italic;
    font-display: fallback;
    src: url(${OpenSansLightItalic}) format('woff');
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 400;
    font-style: normal;
    font-display: fallback;
    src: url(${OpenSansRegular}) format('woff');
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 400;
    font-style: italic;
    font-display: fallback;
    src: url(${OpenSansItalic}) format('woff');
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 600;
    font-style: normal;
    font-display: fallback;
    src: url(${OpenSansSemiBold}) format('woff');
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 600;
    font-style: italic;
    font-display: fallback;
    src: url(${OpenSansSemiBoldItalic}) format('woff');
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 700;
    font-style: normal;
    font-display: fallback;
    src: url(${OpenSansBold}) format('woff');
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 700;
    font-style: italic;
    font-display: fallback;
    src: url(${OpenSansBoldItalic}) format('woff');
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 800;
    font-style: normal;
    font-display: fallback;
    src: url(${OpenSansExtraBold}) format('woff');
  }
  @font-face {
    font-family: 'OpenSans';
    font-weight: 800;
    font-style: italic;
    font-display: fallback;
    src: url(${OpenSansExtraBoldItalic}) format('woff');
  }
  @font-face {
    font-family: 'Roboto';
    font-weight: 500;
    font-style: normal;
    font-display: fallback;
    src: url(${RobotoMedium}) format('ttf');
  }
  body{
    font-family: OpenSans, Manrope, Helvetica, "Helvetica Neue", sans-serif;
  }
  .results-modal-dialog{
    @media (min-width: 576px) {
      max-width: 90%;
    }
    @media (min-width: 1200px) {
      max-width: 1140px;
    }
  }
  mark{
    padding: 0;
    background-color: transparent;
    font-weight: 600; 
    color: #EF1C62;
  }
`;

export default GlobalStyle;